import { render, staticRenderFns } from "./CheckWidget.vue?vue&type=template&id=66d6370f&scoped=true"
import script from "./CheckWidget.vue?vue&type=script&lang=js"
export * from "./CheckWidget.vue?vue&type=script&lang=js"
import style0 from "./CheckWidget.vue?vue&type=style&index=0&id=66d6370f&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "66d6370f",
  null
  
)

export default component.exports